<template>
  <div>
    <el-input
      v-model="dataModel"
      placeholder="请输入"
      type="textarea"
      :rows="3"
      :disabled="disabled"
      :size="size"
      :style="`width: ${width}`"
    ></el-input>
  </div>
</template>

<script>
import FormConfig from "../formConfig"; // 表单配置
// 审核意见
export default {
  name: "Remark",
  props: {
    value: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size
    };
  },
  computed: {
    width() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.width || "auto";
      return status;
    },
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    }
  },
  watch: {
    value(val) {
      this.dataModel = val;
    },
    dataModel(val) {
      this.$emit("input", val);
    }
  }
};
</script>
